"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultipleSelection = void 0;
var utils_1 = require("../utils/utils");
var base_1 = require("./base");
var listener_1 = require("../utils/event-listener/listener");
var element_from_string_1 = require("../utils/element-from-string");
var MultipleSelection = /** @class */ (function (_super) {
    __extends(MultipleSelection, _super);
    function MultipleSelection(element, options) {
        return _super.call(this, element, options) || this;
    }
    MultipleSelection.prototype.render = function () {
        var selection = _super.prototype.render.call(this);
        selection.classList.add('select2-selection--multiple');
        selection.innerHTML = '<ul class="select2-selection__rendered"></ul>';
        return selection;
    };
    MultipleSelection.prototype.binding = function (select, container) {
        var _this = this;
        _super.prototype.binding.call(this, select, container);
        var id = select.id + '-container';
        this.selection
            .querySelector('.select2-selection__rendered')
            .setAttribute('id', id);
        listener_1.createListener({
            elements: this.selection,
            events: 'click',
            listeners: this.core.listeners,
            callback: function (evt) {
                _this.trigger('toggle', {
                    originalEvent: evt
                });
            }
        });
        listener_1.createListener({
            elements: this.selection,
            filter: listener_1.isElementActive('.select2-selection__choice__remove'),
            events: 'click',
            listeners: this.core.listeners,
            callback: function (evt) {
                // Ignore the event if it is disabled
                if (_this.isDisabled()) {
                    return;
                }
                var target = evt.target.closest('.select2-selection__choice__remove');
                var selection = target.parentElement;
                var data = utils_1.Utils.GetData(selection, 'data');
                _this.trigger('unselect', {
                    originalEvent: evt,
                    data: data
                });
            }
        });
        listener_1.createListener({
            elements: this.selection,
            filter: listener_1.isElementActive('.select2-selection__choice__remove'),
            events: 'keydown',
            listeners: this.core.listeners,
            callback: function (evt) {
                if (_this.isDisabled()) {
                    return;
                }
                evt.stopPropagation();
            }
        });
    };
    MultipleSelection.prototype.clear = function () {
        var rendered = this.selection.querySelector('.select2-selection__rendered');
        utils_1.Utils.elementEmpty(rendered);
        rendered.removeAttribute('title');
    };
    MultipleSelection.prototype.display = function (data, container) {
        var template = this.options.get('templateSelection');
        var escapeMarkup = this.options.get('escapeMarkup');
        return escapeMarkup(template(data, container));
    };
    MultipleSelection.prototype.selectionContainer = function () {
        return element_from_string_1.elementFromString('<li class="select2-selection__choice">' +
            '<button type="button" class="select2-selection__choice__remove" ' +
            'tabindex="-1">' +
            '<span aria-hidden="true">&times;</span>' +
            '</button>' +
            '<span class="select2-selection__choice__display"></span>' +
            '</li>');
    };
    MultipleSelection.prototype.update = function (data) {
        this.clear();
        if (data.length === 0) {
            return;
        }
        var selections = [];
        var selectionIdPrefix = this.selection
            .querySelector('.select2-selection__rendered')
            .getAttribute('id') + '-choice-';
        var _loop_1 = function (d) {
            var selection = data[d];
            var selectionContainer = this_1.selectionContainer();
            var formatted = this_1.display(selection, selectionContainer);
            var selectionId = selectionIdPrefix + utils_1.Utils.generateChars(4) + '-';
            if (selection.id) {
                selectionId += selection.id;
            }
            else {
                selectionId += utils_1.Utils.generateChars(4);
            }
            selectionContainer
                .querySelectorAll('.select2-selection__choice__display')
                .forEach(function (el) {
                el.append(formatted);
                el.setAttribute('id', selectionId);
            });
            var title = selectionContainer.title || selectionContainer['text'];
            if (title) {
                selectionContainer.setAttribute('title', title);
            }
            var removeItem = this_1.options.get('translations').get('removeItem');
            selectionContainer
                .querySelectorAll('.select2-selection__choice__remove')
                .forEach(function (removeEl) {
                removeEl.setAttribute('title', removeItem());
                removeEl.setAttribute('aria-label', removeItem());
                removeEl.setAttribute('aria-describedby', selectionId);
            });
            utils_1.Utils.StoreData(selectionContainer, 'data', selection);
            selections.push(selectionContainer);
        };
        var this_1 = this;
        for (var d = 0; d < data.length; d++) {
            _loop_1(d);
        }
        var rendered = this.selection.querySelector('.select2-selection__rendered');
        selections.forEach(function (s) { return rendered.append(s); });
    };
    return MultipleSelection;
}(base_1.BaseSelection));
exports.MultipleSelection = MultipleSelection;
//# sourceMappingURL=multiple.js.map